export const Role = {
  SuperAdmin: "SuperAdmin",
  Admin: "Location Admin",
  CompanyOwner: "Admin",
  CompanyManager: "Manager",
  User: "User",
  CanteenManager: "Canteen Manager",
};
